import React, {useState} from 'react';
import { Link, useRouteMatch } from 'react-router-dom';
import { breadcrumbStyle, linkButton, breadcrumbLinkStyle, breadcrumbTextStyle } from '../Shared/Styles';

function useQuery() {
    return new URLSearchParams(window.location.search);
  }
  
export default function Breadcrumb(props) {
    const queryString = window.location.search;
    let query = useQuery();
    const [policyOrigin] = useState(query.get("policyOrigin"));
    let { url } = useRouteMatch();

    const renderComponent = (component) => {
        
        switch (component) {
            case 'request-policy-documents':
                return (
                    <span> Request Policy Documents</span>
                );

            case 'alter-policy':
                return (
                    <span>Policy Alteration</span>
                );

            case 'policy-exclusions-and-loadings':
                return (
                    <span>View Policy exclusions and Loadings</span>
                );

            case 'payment-details':
                return (
                    <span>View Payment Details</span>
                );

            case 'beneficiaries':
                return (
                    <span>View Beneficiaries Details</span>
                );

            case 'request-existing-business-quote':
                return (
                    <span>Request Existing Business Quote</span>
                );

            case 'request-certificate-of-currency':
                return (
                    <span>View Certificate of Currency</span>
                );

            case 'request-policy-summary':
                return (
                    <span>View Policy Summary</span>
                );

            default: return (
                <span></span>
            );
        }
    }

    return (
        <div style={breadcrumbStyle} className="Breadcrumb">
            <a data-testid="dashboardLink" href="/dashboard" style={breadcrumbLinkStyle}>Dashboard</a> |
            <a data-testid="lifeFullNameLink"
                href={"/dashboard/client-details?clientId=" + props.clientId + "&distributorNo=" + props.distributorNo + "&distributorClientNo=" + props.distributorClientNo}
                style={breadcrumbLinkStyle}>{props.lifeFullName}</a> |
            { (props.appRefNo && props.appRefNo !== 'undefined') &&
                <a data-testid="appRefLink"
                    href={"/dashboard/application-record?appRefNo=" + props.appRefNo + "&distributorNo=" + props.distributorNo + "&distributorClientNo=" + props.distributorClientNo + "&clientId=" + props.clientId}
                    style={breadcrumbLinkStyle}>{props.appRefNo} <span style={breadcrumbTextStyle}>|</span>
                </a>
            }
            {
                (props.endCrumb === 'policy-details') ?
                    <span data-testid="policyNumberText" style={breadcrumbTextStyle}>{props.productName} #{props.policyNumber}</span>
                    :
                    (policyOrigin === 'TAL') ? 
                        <a data-testid="appRefLink"
                        href={"/dashboard/policy-record" + encodeURI(queryString)}
                        style={breadcrumbLinkStyle}>{props.productName} #{props.policyNumber} <span style={breadcrumbTextStyle}>|</span>
                        </a>    
                    :
                    <Link to={`${url}${queryString}`} style={linkButton}>
                        <span style={breadcrumbLinkStyle} href="/">{props.productName} #{props.policyNumber}  <span style={breadcrumbTextStyle}>|</span></span> 
                    </Link>
            }

            {renderComponent(props.endCrumb)}
        </div>
    );
}